import gql from 'graphql-tag';

export const GET_LENDER_TERMS_COMPARISON_TABLE = gql`
  query LenderTermsComparisonTable($input: LenderPerformanceReportInput!) {
    lenderPerformance {
      termsComparisonTable(input: $input) {
        success
        error
        entity {
          lenderProfileId
          lenderName
          avgRate
          rateRange {
            min
            max
          }
          avgTerm
          termOptions
          docFee
          fundedAmount
        }
      }
    }
  }
`;
